import Confetti from "react-dom-confetti";
import { useState } from "react";
import useGet from "src/hooks/rest/useGet";
import { ApiEndorseSkill } from "src/api/types";
import usePatch from "src/hooks/rest/usePatch";
import SkillBadge from "src/components/SkillBadge";

interface EndorsementFormProps {
	userId: number;
	registrationId: number;
}

const EndorsementForm = ({ userId, registrationId }: EndorsementFormProps) => {
	const [{ data }] = useGet(`/users/${userId}/skills`);

	if (!data || data.length === 0) {
		return <></>;
	}

	return (
		<>
			<div className="flex flex-wrap items-center gap-2">
				{data.map((skill: ApiEndorseSkill) => (
					<EndorsementItem
						{...{ skill, registrationId }}
						key={`skill-${skill.id}`}
					/>
				))}
			</div>
		</>
	);
};

interface EndorsementItemProps {
	skill: ApiEndorseSkill;
	registrationId?: number;
}

const EndorsementItem = ({ skill, registrationId }: EndorsementItemProps) => {
	const [hasEndorsed, setHasEndorsed] = useState(skill.has_endorsed);
	const [likes, setLikes] = useState(skill.endorsements);
	const [endorse] = usePatch(
		`/company/endorsements/${registrationId}/${skill.id}`
	);
	const [runConfetti, setRunConfetti] = useState(false);

	const onClick = async () => {
		if (!registrationId) return;
		setHasEndorsed(!hasEndorsed);

		const { data } = await endorse({});
		setLikes(data?.endorsements);
		if (data?.has_endorsed) {
			setRunConfetti(true);
			setTimeout(() => setRunConfetti(false), 400);
		}
	};

	return (
		<>
			<SkillBadge
				onClick={registrationId ? onClick : undefined}
				skill={{
					...skill,
					endorsements: likes,
					has_endorsed: hasEndorsed,
				}}
			/>
			<Confetti active={runConfetti} />
		</>
	);
};

export default EndorsementForm;
